export function getUsagePredictionColor(averageUsageDays, operationalCylinder) {
  if (operationalCylinder === null || averageUsageDays === 0) {
    return {
      txtClr: "text-gray-600",
      border: "border-gray-300",
    };
  } else if (averageUsageDays <= 7) {
    return {
      txtClr: "text-red-600",
      border: "border-red-300",
    };
  } else if (averageUsageDays <= 30) {
    return {
      txtClr: "text-[#E05706]",
      border: "border-[#E05706]",
    };
  } else {
    return {
      txtClr: "text-lime-600",
      border: "border-lime-300",
    };
  }
}

export function getremainDaysColor(days) {
  if (days === null) {
    return {
      remBorder: "border-gray-30",
      remTxtClr: "text-gray-600",
      bgClr: "bg-gray-100",
      boxBorder: "border-gray-200",
    };
  } else if (days < 0) {
    return {
      remBorder: "border-red-300",
      remTxtClr: "text-red-600",
      bgClr: "bg-red-50",
      boxBorder: "border-red-200",
    };
  } else if (days === 0) {
    return {
      remBorder: "border-[#E05706]",
      remTxtClr: "text-[#E05706]",
      bgClr: "bg-[#ef8a4421]",
      boxBorder: "border-[#FFC696]",
    };
  } else {
    return {
      remBorder: "border-lime-300",
      remTxtClr: "text-lime-600",
      bgClr: "bg-lime-50",
      boxBorder: "border-lime-200",
    };
  }
}
